export default {
  nav_home: 'HOME',
  nav_about: 'ABOUT',
  nav_services: 'SERVICES',
  nav_contact: 'CONTACT',
  nav_call_us: 'Call Us',
  nav_get_quote: 'Get a Quote',
  nav_menu: 'Menu',

  footer_company_desc: 'FMO LLC specializes in high-quality insulation solutions for residential and commercial properties in Lafayette, Indiana and surrounding communities. Over 15 years of experience improving energy efficiency and indoor comfort.',
  footer_phone: '(574) 721-9810',
  footer_email: 'miguelceo@fmoinsulation.com',
  footer_navigation: 'Navigation',
  footer_nav_home: 'Home',
  footer_nav_services: 'Services',
  footer_nav_about: 'About',
  footer_nav_contact: 'Contact',
  footer_our_services: 'Our Services',
  footer_service_spray_foam: 'Spray Foam Insulation',
  footer_service_batt: 'Batt Insulation',
  footer_service_cellulose: 'Cellulose Insulation',
  footer_service_attic: 'Attic Insulation',
  footer_service_walls: 'Wall Insulation',
  footer_service_crawl: 'Crawl Space Insulation',
  footer_contact: 'Contact',
  footer_address_line1: 'PO Box 4742',
  footer_address_line2: 'Lafayette, IN 47903',
  footer_hours_title: 'Business Hours',
  footer_hours_weekdays: 'Mon - Fri: 8:00 AM - 7:00 PM',
  footer_hours_weekends: 'Sat - Sun: 9:00 AM - 6:00 PM',
  footer_copyright: '\u00A9 2026 FMO LLC Insulation Services. All rights reserved.',
  footer_serving: 'Serving Lafayette, Indiana and surrounding communities.',

  common_read_more: 'Read More',
  common_learn_more: 'Learn More About Us',
  common_view_all: 'View All',
  common_request_quote: 'Request a Free Quote',
  common_request_this_service: 'Request This Service',
  common_free_estimate: 'Free Estimates',
  common_free_estimates: 'Estimates Available',
  common_send: 'Send',
  common_sending: 'Sending...',
  common_success: 'Request Submitted!',
  common_success_contact: 'We will contact you soon.',
  common_success_24h: 'We will contact you within 24 hours.',
  common_send_another: 'Send another request',
  common_error: 'An error occurred. Please try again.',
  common_error_spam: 'Your message was flagged as spam. Please try again.',
  common_error_connection: 'Connection error. Please try again.',
  common_years_experience: 'Years of Experience',
  common_satisfaction_guaranteed: 'Satisfaction Guaranteed',
  common_local: 'Family Owned Local',
  common_scroll: 'Scroll',
  common_name: 'Name',
  common_full_name: 'Full Name',
  common_first_name: 'First Name',
  common_last_name: 'Last Name',
  common_email: 'Email',
  common_phone: 'Phone Number',
  common_address: 'Property Address',
  common_service_needed: 'Service Needed',
  common_message: 'Message / Comments',
  common_select_service: 'Select a service',
  common_required: 'Required',
  general_consultation: 'General Consultation',
  spray_foam: 'Spray Foam Insulation',
  batt_insulation: 'Batt Insulation',
  roll_insulation: 'Roll Insulation',
  cellulose_insulation: 'Cellulose Insulation',
  blown_in_insulation: 'Blown-In Insulation',
  attic_insulation: 'Attic Insulation',
  wall_insulation: 'Wall Insulation',
  crawl_space_insulation: 'Crawl Space Insulation',
  metal_building_insulation: 'Metal Building Insulation',
  spray_foam_closed: 'Closed Cell Spray Foam',
  spray_foam_open: 'Open Cell Spray Foam',
};